import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ApiConfiguration } from '@klubovna/api-client';
import {
  stockAdjustmentsControllerCreate,
  StockAdjustmentsControllerCreate$Params,
  stockAdjustmentsControllerFindAll,
  StockAdjustmentsControllerFindAll$Params,
  stockAdjustmentsControllerFindById,
} from '@klubovna/api-client';
import { CreateStockAdjustmentDto, StockAdjustment } from '@klubovna/api-client';
import { PaginatedResponse, toPaginatedResponse } from '@klubovna/api-client';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class StockAdjustmentsApiService {
  private http = inject(HttpClient);
  private apiConfig = inject(ApiConfiguration);

  findAll(params?: StockAdjustmentsControllerFindAll$Params): Observable<PaginatedResponse<StockAdjustment>> {
    return stockAdjustmentsControllerFindAll(this.http, this.apiConfig.rootUrl, params)
      .pipe(map(response => toPaginatedResponse<StockAdjustment>(response.body)));
  }

  findById(id: string): Observable<StockAdjustment> {
    return stockAdjustmentsControllerFindById(this.http, this.apiConfig.rootUrl, { id })
      .pipe(map(response => response.body as StockAdjustment));
  }

  create(data: CreateStockAdjustmentDto): Observable<StockAdjustment> {
    const params: StockAdjustmentsControllerCreate$Params = { body: data };
    return stockAdjustmentsControllerCreate(this.http, this.apiConfig.rootUrl, params)
      .pipe(map(response => response.body as StockAdjustment));
  }
}
